import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { BrandLogo } from "./BrandLogo";

export function PublicLayout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="site-header">
        <div className="container inner">
          <Link to="/" className="brand brand-with-logo" onClick={() => setOpen(false)}>
            <BrandLogo variant="header" />
          </Link>
          <button
            className="mobile-nav-toggle"
            type="button"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
          >
            Menu
          </button>
          <nav className={`nav ${open ? "open" : ""}`} onClick={() => setOpen(false)}>
            <a href="/#audiences">Who we help</a>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/au/services" className="nav-sub">
              AU
            </NavLink>
            <NavLink to="/sg/services" className="nav-sub">
              SG
            </NavLink>
            <NavLink to="/consulting">Consulting</NavLink>
            <NavLink to="/equipment">Equipment</NavLink>
            <NavLink to="/pricing">Pricing</NavLink>
            <NavLink to="/resources">Resources</NavLink>
            <NavLink to="/reports">Guided Reports</NavLink>
            <NavLink to="/contact">Contact</NavLink>
            {user ? (
              <>
                <NavLink to="/dashboard">Dashboard</NavLink>
                {(user.role === "admin" || user.role === "reviewer") && (
                  <NavLink to="/admin">Admin</NavLink>
                )}
                <button
                  className="btn btn-secondary btn-sm nav-cta"
                  type="button"
                  onClick={() => void logout()}
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <NavLink to="/login">Sign in</NavLink>
                <Link className="btn btn-primary btn-sm nav-cta" to="/register">
                  Create account
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="container">
          <div className="footer-grid">
            <div>
              <div className="brand brand-with-logo" style={{ marginBottom: "0.9rem" }}>
                <BrandLogo variant="footer" />
              </div>
              <p style={{ maxWidth: "36ch", fontSize: "0.92rem" }}>
                Ecological Engineering
              </p>
              <p style={{ maxWidth: "36ch", fontSize: "0.92rem", margin: "0 0 0.35rem" }}>
                Australia
              </p>
              <p style={{ maxWidth: "36ch", fontSize: "0.92rem", margin: "0 0 0.35rem" }}>
                GST invoices
              </p>
              <p style={{ maxWidth: "36ch", fontSize: "0.92rem", margin: 0 }}>
                Contact:{" "}
                <a href="mailto:info@ecoeng.net">info@ecoeng.net</a>
              </p>
            </div>
            <div>
              <h4>Get started</h4>
              <ul>
                <li>
                  <Link to="/resources">Download tools</Link>
                </li>
                <li>
                  <Link to="/reports">Guided reports (~48h)</Link>
                </li>
                <li>
                  <Link to="/pricing">Pricing</Link>
                </li>
                <li>
                  <Link to="/dashboard">Client dashboard</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li>
                  <Link to="/consulting">Consulting</Link>
                </li>
                <li>
                  <Link to="/equipment">Equipment</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/au/services">Australia services</Link>
                </li>
                <li>
                  <Link to="/sg/services">Singapore services</Link>
                </li>
                <li>
                  <Link to="/track-record">Track record</Link>
                </li>
                <li>
                  <Link to="/contact">Talk to us</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4>Legal</h4>
              <ul>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/professional-responsibility">Professional responsibility</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <span>© {new Date().getFullYear()} Ecological Engineering · EcoEng.net</span>
            <span>Tools · Guided reports · Project delivery</span>
          </div>
        </div>
      </footer>
    </>
  );
}

export function DashboardShell({
  title,
  subtitle,
  children,
  nav,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  nav: Array<{ to: string; label: string }>;
}) {
  return (
    <div className="dash-layout">
      <aside className="dash-side">
        {nav.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.to.split("/").length <= 2}>
            {item.label}
          </NavLink>
        ))}
      </aside>
      <div className="dash-main">
        <h1>{title}</h1>
        {subtitle ? <p className="muted">{subtitle}</p> : null}
        {children}
      </div>
    </div>
  );
}
